import {useEffect} from 'react';

import {addSsoLink} from '@/state/ducks/externalLinks';
import {dispatch} from '@/state/store';

type Args = {
    expirationDate?: number;
    formattedSsoTemplate: string | null;
};

const getLinkExpiration = (expirationDate: number) => {
    const expiredInMs = expirationDate - Date.now();

    return {
        expiredInMs,
        isExpired: expiredInMs < 0,
    };
};

/**
 * Clears the cached SSO link from the store as soon as it expires so that the
 * next `useExternalLinks` render re-requests it from the host.
 */
const useSsoLinkRefresh = ({expirationDate, formattedSsoTemplate}: Args) => {
    useEffect(() => {
        if (!expirationDate || !formattedSsoTemplate) return;

        const {expiredInMs, isExpired} = getLinkExpiration(expirationDate);
        const timeoutMs = isExpired ? 0 : expiredInMs;

        const timeout = setTimeout(() => {
            dispatch(addSsoLink({template: formattedSsoTemplate}));
        }, timeoutMs);

        return () => clearTimeout(timeout);
    }, [expirationDate, formattedSsoTemplate]);
};

export default useSsoLinkRefresh;
